(ns ui.components.card.view)

(defn card
  [& children]
  (into
   [:div
    {:class "overflow-hidden rounded-lg shadow"}]
   children))

(defn header
  [& children]
  (into
   [:div
    {:class "px-4 py-4 flex justify-between items-center *:font-bold *:text-md border-b border-solid border-base-light-border-paler"}]
   children))

(defn body
  [& children]
  (into
   [:div
    {:class "px-4 py-5"}]
   children))
